import { LandingLayoutWithLandingDescription } from "PFApp/components/landing_layout";
import { Alert } from "PFComponents/alert";
import { Button } from "PFComponents/button";
import { LoadingDots } from "PFComponents/loading_dots";
import { InputFieldSet } from "PFComponents/text/input_field_set";
import useIsFeatureEnabled from "PFCore/helpers/use_is_feature_enabled";
import { useCurrentAccount } from "PFCore/hooks/queries/account/use_current_account";
import { useForgotPassword } from "PFCore/hooks/queries/auth/use_forgot_password";
import { FeatureFlag } from "PFTypes";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import css from "./forgot_password.module.scss";

export const ForgotPasswordPage = () => {
  const [email, setEmail] = useState("");

  const { data: currentAccount } = useCurrentAccount();
  const { t } = useTranslation();

  const { mutate: forgotPassword, isPending, data } = useForgotPassword();

  const submit = (event) => {
    event.preventDefault(); // prevent form submit navigation

    forgotPassword({
      email,
      accountId: currentAccount.id
    });
  };

  const isPasswordSignInEnabled = useIsFeatureEnabled(FeatureFlag.PasswordSignin);
  const isRequestAccessEnabled = useIsFeatureEnabled(FeatureFlag.RequestAccess);

  return (
    <LandingLayoutWithLandingDescription>
      <strong data-qa-id="ForgotPasswordPage.header">{t("forgotPassword.resetPassword")}</strong>

      {data?.message && (
        <Alert className={css.marginBottom} kind="success" qaId="ForgotPasswordPage.successMessage">
          {data?.message}
        </Alert>
      )}

      <form
        onSubmit={submit}
        aria-label={t("forgotPassword.resetPassword")}
        data-qa-id="ForgotPasswordPage.form"
      >
        <InputFieldSet
          qaId="ForgotPasswordPage.email"
          label={t("forgotPassword.emailAddress")}
          className={css.marginBottom}
          onChange={setEmail}
        />

        <Button qaId="ForgotPasswordPage.submit" className={css.button} disabled={email.trim() === ""}>
          {isPending ? <LoadingDots /> : t("forgotPassword.sendInstructions")}
        </Button>
      </form>

      <div className={css.marginBottom}>
        <Link to="/users/signin" data-qa-id={"ForgotPasswordPage.signInLink"}>
          {t("forgotPassword.signIn")}
        </Link>
      </div>

      {isPasswordSignInEnabled && (
        <>
          <div>
            <span>{t("forgotPassword.dontHaveAccount")}</span>
          </div>
          <div>
            <Link
              data-qa-id={
                isRequestAccessEnabled ? "ForgotPasswordPage.requestAccess" : "ForgotPasswordPage.signUp"
              }
              to={isRequestAccessEnabled ? "/request_access" : "/users/signup"}
            >
              {t("forgotPassword.signUp")}
            </Link>
          </div>
        </>
      )}
    </LandingLayoutWithLandingDescription>
  );
};
